import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryDeparturesData = Offers.Endpoints.Departures;

interface UseQueryDeparturesOptions {
  initialData?: UseQueryDeparturesData;
}

const useQueryDepartures = ({ initialData }: UseQueryDeparturesOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryDeparturesData>(
    [QueryId.DEPARTURES, locale],
    async () => {
      const baseUrl = '/api/departures';

      const fetchResponse = await fetch(baseUrl, {
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
        },
        method: 'GET',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryDepartures', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: true,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryDepartures;
